/* global Clipboard */
FD.PURCHASEORDER = (function ($, me) {
    'use strict';

    var child = me.PURCHASEORDER || {};


    /* ========================================================================
     *  Global Variables
     * ========================================================================
    */

    // Constants
    var URL_IAS = '/IAS/Modules/';
    var URL_IAS_MAIN = '/IAS/IAS/';
    var URL_IAS_COSIGN = '/IAS/ManageCoSigning/';
    var URL_MEDIA = "/Common/Media/HandleImageUpload";
    var MODAL_ELEM = '#PURCHASEORDER_MODAL';
    var PURCHASEORDER_FORM = '#PURCHASEORDER_FORM';
    var APPROVAL_COMMENT = '#APPROVAL_COMMENT';
    var LINE_ITEMS_CONTAINER = '#LINE_ITEMS_CONTAINER';
    var HARD_COPY_DETAILS = '#HARD_COPY_DETAILS';
    var PO_SMART_SECTION = '#PO_SMART_SECTION';
    var POMODULE_PARENT_ACCOUNT_HELP_TEXT = '#POMODULE_PARENT_ACCOUNT_HELP_TEXT';
    var POMODULE_ACCOUNT_HELP_TEXT = '#POMODULE_ACCOUNT_HELP_TEXT';
    var APPROVAL_BODY = '#APPROVAL_BODY';
    var ATTACH_FILE_MODAL = '#ATTACH_FILE_MODAL';
    var APPROVE_MODAL = '#CONFIRMATION_MODAL';
    var TOTAL_AMOUNT = '#TOTAL_AMOUNT';
    var ORIGINAL_AMOUNT = '#ORIGINAL_AMOUNT';
    var SUPPORTING_DOCUMENTATION_ROW_DATA = '#SUPPORTING_DOCUMENTATION_ROW_DATA';
    var PAYMENT_TERMS = '#PAYMENT_TERMS';
    var isPurchasedMaterial = false;
    var CALLBACK_PREFIX = 13;
    var MAIN_ROWDATA_ELEM = '#MAIN_ROWDATA';
    var NEW_REVISION_LINE_ITEM_TABLE = '#NEW_REVISION_LINE_ITEM_TABLE';
    var RevLineItem = '.RevLineItem';
    const dropZone = '[data-fd="dropzone"]';
    const OTHER_TEAMMATES_TABLE = "#OTHER_TEAMMATES_TABLE";
    var currentFile = null;

    //  Variables
    var notify;
    var labelList;
    var approvalUpdateItem;
    var contpaqSelectedAccountID = null;
    var purchaseOrderCoSignersID;
    var lowestPurchaseOrderCoSignerID;
    var isLastCosigner;

    var oldPrice = 0;
    var totalAmount = 0;
    var isNew = true;
    var isdraft = true;
    var collapseHardCopyDetails = true;

    var poItem;
    var poModulePerspectiveType = {
        ADD: "ADD",
        EDIT: "EDIT",
        DUPLICATE: "DUPLICATE",
        VIEW: "VIEW",
        APPROVE: "APPROVE",
        PREFILL: "PREFILL"
    };
    var iasApprovalStatus = {
        NEEDS_APPROVAL: 1,
        APPROVED: 2,
        WAIT_MOREINFO_NEEDED: 3,
        REJECTED: 4,
        EDITING: 5
    };
    var purchaseOrderSourceType = {
        STANDARD: 0,
        SPARE_PARTS: 1,
        PURCHASE_MATERIAL: 2
    };
    var poType = {
        BLANKET: 1,
        SPOT_BUY: 2
    };
    var lineItemType = {
        SIMPLE: 1,
        DETAILED: 2
    };
    var currentStateItem = {
        IsMexicoFocusFactory: false,
        IsPrimaryApproverRequired: false,
        IsAlignmentRequired: false,
        IsSpendingLimitApproverRequired: false,
        IsContpaqVendor: false,
        LineItemType: lineItemType.SIMPLE,
        SpendingLimit: 0,
        POType: null
    };

    // Default Module Options
    var addDefaults = {
        showCallback: null,
        addCallback: null,
        hideCallback: null,
        loadingElements: null,
        showCreateAnotherPOButton: null,
        perspectiveType: poModulePerspectiveType.ADD
    };
    var duplicateDefaults = {
        showCallback: null,
        addCallback: null,
        hideCallback: null,
        poID: null,
        loadingElements: null,
        showCreateAnotherPOButton: null,
        perspectiveType: poModulePerspectiveType.DUPLICATE
    };
    var editDefaults = {
        poID: null,
        showCallback: null,
        updateCallback: null,
        hideCallback: null,
        loadingElements: null,
        showCreateAnotherPOButton: null,
        perspectiveType: poModulePerspectiveType.EDIT
    };
    var viewDefaults = {
        poID: null,
        showCallback: null,
        hideCallback: null,
        loadingElements: null,
        perspectiveType: poModulePerspectiveType.VIEW
    };
    var approveDefaults = {
        showCallback: null,
        updateApprovalCallback: null,
        updateAlignmentCallback: null,
        hideCallback: null,
        loadingElements: null,
        isAlignment: false,
        perspectiveType: poModulePerspectiveType.APPROVE
    };
    var prefillDefaults = {
        showCallback: null,
        addCallback: null,
        hideCallback: null,
        loadingElements: null,
        showCreateAnotherPOButton: null,
        perspectiveType: poModulePerspectiveType.PREFILL,
        prefilledPOItem: {},
        disabledFieldsItem: {}
    };
    var purchaseOrderOptions;
    var validateLineItem = false;
    var addNotePopup = false;
    var lineitemChangeConfirmed = false;
    var forceSubmitWithoutAttachment = false;
    var showAttachment = false;
    var isDirty = false;
    var resubmitIsRequired = false;
    var questionsChanged = false;


    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        BTN_ADD_PO_RESULT: 14,
        BTN_EDIT_PO_RESULT: 15,

        DIVISION: 40,
        CELL: 41,

        ECN: 42,
        ToolingBuild: 43,
        Tooling: 44,
        MachineBuild: 45,

        PARENTACCOUNT: 50,
        ACCOUNT: 51,
        LINE_ITEM_PRICE: 52,
        CURRENCY: 53,
        PO_DIVISIONAL_ADVISOR: 54,
        VENDOR: 55,
        TOOL_CODE: 56,
        CAPITAL_CODE: 57,
        PO_ADVISOR: 59,
        PO_PURCHASER: 303,
        ETA: 60,
        PO_DESCRIPTION: 61,
        EXPIRATION_DATE: 62,

        ADD_VENDOR: 63,
        EDIT_VENDOR: 64,

        ADD_LINE_ITEM: 66,
        DELETE_LINE_ITEM: 67,
        LINE_ITEM_QTY: 68,

        SUBMIT_FOR_APPROVAL: 70,
        SAVE_DRAFT: 71,
        SAVEBTN: 72,
        JOB_ID: 73,

        APPROVE: 80,
        SHOW_POPUP: 86,
        WAIT_MOREINFO: 81,
        DECLINEPO: 82,
        CONFIRM_DECLINEPO: 83,
        CANCEL_DECLINEPO: 84,
        WAIT_APPROVER: 87,
        CONTINUE_APPROVE: 88,

        CREDIT_CARD: 85,

        SHIPPING_TERMS: 90,
        SUPPLIER_CONTACT: 91,
        SHIP_VIA: 92,
        SHIP_TO: 93,
        SHIP_TO_CONTACT: 94,
        BLANKET_PO_NUMBER: 95,
        SALES_TAX: 96,
        SHIPPING_AND_HANDLING: 97,
        DISCOUNT: 98,
        SPECIAL_NOTES: 99,

        TOGGLE_SECTION: 100,
        SAVE_AND_EXPORT_PO: 101,
        SELECT_POTYPE: 102,
        SELECT_POSTATUS: 103,

        LINE_ITEM_PART_NUMBER: 110,
        LINE_ITEM_PART_DESCRIPTION: 111,
        LINE_ITEM_ETA: 112,
        LINE_ITEM_UNIT_OF_MEASURE: 113,
        LINE_ITEM_CONTPAQ_ID: 114,

        LINE_ITEM_MATERIAL: 121,

        MIGRATE_LINE_ITEM_MATERIAL: 122,
        MIGRATE_OPEN_MODAL: 123,
        MIGRATE_SUBMIT: 124,
        IS_RECEIVED: 125,

        SELECT_JOB_TYPE: 130,
        SELECT_CAPEX_PASSTHRU_ITEM: 131,
        DOCK_NUMBER: 132,

        PURCHASER_COMMENT_CONTINUE: 140,
        PURCHASER_COMMENT_RESUBMIT: 141,
        PURCHASER_ADD_COMMENT: 142,

        CREATE_NEW_REVISION: 150,
        APPROVE_NEW_REVISION: 151,

        UPLOAD_DOCUMENT: 202,
        ENTITY_ATTACHMENT_ADD: 200,
        ENTITY_ATTACHMENT_REMOVE: 201,

        CONFIRM_NEWVALUE: 205,
        CANCEL_NEWVALUE: 206,
        CONFIRM_RESUBMIT: 208,

        CONFIRM_ADD_NOTE: 207,

        SUBMIT_WITH_ATTACHMENT: 301,
        SUBMIT_WITHOUT_ATTACHMENT: 302,

        DELETE_REV_LINE_ITEM: 220,
        ADD_REV_LINE_ITEM: 221,
        ADD_REV_PurchasedMaterial: 222,
        ADD_REV_ContpaqProduct: 223,

        Add_Other_Teammate: 251,
        Delete_Other_Teammate: 252
    };


    /*
    * ========================================================================
    * Objects
    * ========================================================================
    */


    function setPOApprovalUpdateItem() {
        return {
            POID: purchaseOrderOptions.poID,
            ApprovalStatus: null,
            Comment: null,
            PurchaseOrderCoSignersID: null,
            IsIssued: false,
            ApprovalWaitForPreviousApprover: false
        };
    }


    /*
    * ========================================================================
    * CRUD Functions
    * ========================================================================
    */


    function handlePurchaseOrderAddCRUD(data) {
        var modal = $(MODAL_ELEM);

        if (purchaseOrderOptions.addCallback && typeof purchaseOrderOptions.addCallback === 'function') {
            purchaseOrderOptions.addCallback(purchaseOrderOptions.poID);
            $(MODAL_ELEM + ' .modal-footer .btn-primary').attr('disabled', false).prop('disabled', false);
        }
        modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
            modal.off().html(data).on('shown.bs.modal', function () {
                modal.enableControls();
                if ($('.copyBtn', MODAL_ELEM).length) {
                    var clipboard = new Clipboard(MODAL_ELEM + ' .copyBtn');
                }
            }).on('hidden.bs.modal', handlePOModuleCleanup).modal('show');
        });
        modal.modal('hide');

    }


    function handlePurchaseOrderUpdate(isExport, data) {
        var modal = $(MODAL_ELEM);

        if (purchaseOrderOptions.updateCallback && typeof purchaseOrderOptions.updateCallback === 'function') {
            purchaseOrderOptions.updateCallback(purchaseOrderOptions.poID);
        }
        if (isExport) {
            var link = document.createElement('a');
            link.id = "DELETE_ME";
            link.target = "_blank";
            link.href = URL_IAS + "/ExportPurchaseOrderToPDF/" + purchaseOrderOptions.poID;
            document.body.appendChild(link);
            link.click();
            $(link).remove();
        }
        me.setModalLock(true);
        if (data != true) {
            modal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                modal.html(data).off().on('shown.bs.modal', function () {
                    modal.enableControls();
                    var clipboard = new Clipboard(MODAL_ELEM + ' .copyBtn');
                    me.setModalLock(false);
                }).on('hidden.bs.modal', function () {
                    handlePOModuleCleanup();
                }).modal('show');
            }).modal('hide');
        }

    }

    var hasError = false;
    function handlePOSubmit(data, isExport) {
        validateLineItem = !lineitemChangeConfirmed;
        $(MODAL_ELEM + ' .modal-footer .btn-primary').addClass('disabled').data('noedit', true).attr('data-noedit', true);
        hasError = false;

        if (!me.CONTROL.Validate(MODAL_ELEM)) {
            hasError = true;
        }

        if (!hasError && $("[name*=ReviewedQuestions]", MODAL_ELEM).length > 0 && $("[name*=ReviewedQuestions]", MODAL_ELEM).val() != 'true') {
            notify.alert(labelList["YouMustConfirmYouHaveReviewedQuestions"]);
            hasError = true;
        }

        if (!hasError && $("[name*=PartNumber],[name*=ContpaqProductCode]", LINE_ITEMS_CONTAINER).length === 0) {
            notify.alert(labelList["YouMustHaveAtLeastOneLineItemOrPurchasedMaterialToSubmitPO"]);
            hasError = true;
        }

        var paymentTerms = $(PAYMENT_TERMS)[0].innerText;
        if (!hasError && $("#POItem_IsPurchasedMaterialPO").val().toLowerCase() == "true" && paymentTerms.length == 0) {
            notify.alert(labelList["YouMustSelectPaymentTerms"]);
            hasError = true;
        }

        var attachmentCounter = $(SUPPORTING_DOCUMENTATION_ROW_DATA).data('counter');
        if (!hasError && $("#POItem_IsCheckForFileAttachmentsOnSubmit").val().toLowerCase() == "true"
            && !forceSubmitWithoutAttachment && (attachmentCounter == 0 || attachmentCounter == null)
            && ($("#POItem_IsDraft").val().toLowerCase() == "true" || $("#PerspectiveType").val() == "ADD" || $("#PerspectiveType").val() == "DUPLICATE")
        ) {
            hasError = true;
            me.setConfirmDialogue(labelList['SubmitPOSupportingDocumentationAlert'], tag.SUBMIT_WITH_ATTACHMENT, tag.SUBMIT_WITHOUT_ATTACHMENT, 'PURCHASE_ORDER', null, labelList['AttachSupportingDocumentation'], labelList['SubmitWithoutSupportingDocumentation']);
        }

        if (!hasError && resubmitIsRequired
            && ($("#POItem_IsDraft").val().toLowerCase() == "false" && ($("#PerspectiveType").val() == "EDIT" || $("#PerspectiveType").val() == "VIEW"))) {
            me.setConfirmDialogue(labelList['ChangeSubmittedPOValueBeyondAllowableParameter'], tag.CONFIRM_RESUBMIT, tag.CANCEL_NEWVALUE, 'PURCHASE_ORDER');
            hasError = true;
        }

        if (!hasError && isDirty
            && ($("#POItem_IsDraft").val().toLowerCase() == "false" && ($("#PerspectiveType").val() == "EDIT" || $("#PerspectiveType").val() == "VIEW"))) {
            showAddNoteModal('PURCHASE_ORDER');
            hasError = true;
        }

        if (!hasError && isExport && $("[name*=ShipToLocationID]", MODAL_ELEM).val() == "-1") {
            notify.alert(labelList["YouMustSelectShipToBeforeExportingPO"]);
            hasError = true;
        }

        forceSubmitWithoutAttachment = false;

        if (hasError) {
            $(MODAL_ELEM + ' .modal-footer .btn-primary').removeClass('disabled').data('noedit', false).attr('data-noedit', false);
        }
    }

    function getTotalAmount() {
        return parseFloat($(TOTAL_AMOUNT).html().replaceAll(',', ''));
    }

    function getOldPrice() {
        return parseFloat($("#POItem_Price").val().replaceAll(',', ''));
    }

    function getCosignerThreshold() {
        return parseFloat($("#POItem_CosignerThreshold").val().replaceAll(',', ''));
    }



    function checkForAmountLimits() {
        totalAmount = getTotalAmount();
        oldPrice = getOldPrice();
        var originalAmount = parseFloat($("#POItem_OriginalAmount").val().replaceAll(',', ''));
        var difference = (totalAmount > originalAmount ? (totalAmount - originalAmount) : (originalAmount - totalAmount));
        var isFinanceCRDR = $("#FinanceCRDR").val() == "True" ? true : false;

        if (totalAmount != oldPrice && !lineitemChangeConfirmed && !isNew && !isdraft && purchaseOrderOptions.perspectiveType != poModulePerspectiveType.DUPLICATE) {
            addNotePopup = true;
        } else {
            addNotePopup = false;
        }

        if (totalAmount == originalAmount || totalAmount == oldPrice && purchaseOrderOptions.perspectiveType != poModulePerspectiveType.DUPLICATE) {
            return true;
        }
        else if (isFinanceCRDR) {
            return true;
        }
        else {
            if (difference <= 100 && purchaseOrderOptions.perspectiveType != poModulePerspectiveType.DUPLICATE) {
                return true;
            } else if (difference <= (0.1 * originalAmount) && difference <= 500 && purchaseOrderOptions.perspectiveType != poModulePerspectiveType.DUPLICATE) {
                return true;
            } else {
                return false;
            }
        }
    }

    function isResubmitRequired() {
        let oldDivision = parseFloat($("#OldDivisionID").val());
        let newDivision = parseFloat($('[data-fldname="DivisionID"]').val());

        let oldParentAccount = parseFloat($("#OldParentAccountID").val());
        let newParentAccount = parseFloat($('[data-fldname="ParentAccountID"]').val());

        let oldAccount = parseFloat($("#OldAccountID").val());
        let newAccount = parseFloat($('[data-fldname="AccountID"]').val());

        let oldCoSigner1 = parseFloat($("#OldAdvisorID").val());
        let newCoSigner1 = parseFloat($('[data-fldname="AdvisorID"]').data('value'));

        return oldDivision != newDivision || oldParentAccount != newParentAccount || oldAccount != newAccount || oldCoSigner1 != newCoSigner1;
    }

    function handleSaveDraft(data) {
        if (me.CONTROL.Validate(LINE_ITEMS_CONTAINER + ' [data-quantity]')) {
            $("[name=SaveDraftMode]", MODAL_ELEM).val(data.value).change();
        }
    }
    function handleApprovalStatus(data) {
        var modal = $(MODAL_ELEM);
        approvalUpdateItem = setPOApprovalUpdateItem();
        approvalUpdateItem.PurchaseOrderCoSignersID = purchaseOrderCoSignersID;
        approvalUpdateItem.Comment = $("[data-fldname=APPROVAL_COMMENT_" + purchaseOrderCoSignersID + "]").val();

        if (data.tag == tag.APPROVE || data.tag == tag.CONTINUE_APPROVE) {
            approvalUpdateItem.ApprovalStatus = iasApprovalStatus.APPROVED;
            if (isLastCosigner == "true") {
                approvalUpdateItem.IsIssued = true;
            }
        } else if (data.tag == tag.WAIT_MOREINFO) {
            approvalUpdateItem.ApprovalStatus = iasApprovalStatus.WAIT_MOREINFO_NEEDED;
        } else if (data.tag == tag.WAIT_APPROVER) {
            approvalUpdateItem.ApprovalStatus = iasApprovalStatus.APPROVED;
            approvalUpdateItem.ApprovalWaitForPreviousApprover = true;
        } else {
            approvalUpdateItem.ApprovalStatus = iasApprovalStatus.REJECTED;
        }

        var options = {
            url: URL_IAS + 'HandlePurchaseOrderCosignerStatusCRUD',
            params: {
                item: approvalUpdateItem,
                tag: data.tag
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };
        var totalAmount = getTotalAmount();
        var commentThreshold = parseFloat($("#POItem_CommentThreshold").val().replaceAll(',', ''));
        var isCommentRequired = totalAmount > commentThreshold;
        if (approvalUpdateItem.Comment == "" && isCommentRequired) {
            notify.alert(labelList["CommentIsRequired"]);
        } else {
            me.AJAX.setAJAX(options);
        }
        modal.modal('hide');

        function afterData(result) {
            if (result) {
                $(APPROVAL_BODY).html(result.data).enableControls();
            }
            if (purchaseOrderOptions.perspectiveType != poModulePerspectiveType.APPROVE) {
                getSinglePORow();
            }
            if (purchaseOrderOptions.perspectiveType == poModulePerspectiveType.APPROVE) {
                getApprovalRequests();
            }
        }
    }

    function getApprovalRequests() {
        var divisionID = $("[data-name=divisionFocusFactoryID]").val();
        var cellID = $("[data-name=cellID]").val();
        var entityID = Number(cellID) === -1 ? divisionID : cellID;
        var consignerID = $("[data-name=cosignerID]").val();

        var options = {
            url: URL_IAS_COSIGN + "GetApprovalRequests",
            params: {
                EntityID: entityID,
                CosignerUserID: consignerID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result) {
                $(MANAGE_APPROVER_TABLE).html(result.data);
                me.CONTROL.setButton(true, MANAGE_APPROVER_TABLE);
            }
        }
    }

    function getSinglePORow() {

        var options = {
            url: URL_IAS_MAIN + "GetSinglePORow",
            params: {
                poID: purchaseOrderOptions.poID
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                var trPO = $("tr[data-parentid='" + purchaseOrderOptions.poID + "']");
                if (trPO.length > 0) {
                    trPO.replaceWith(result.data);
                    trPO = $("tr[data-parentid='" + purchaseOrderOptions.poID + "']"); //fetch dom again after replace html
                    trPO.find('span.row-counter').html(trPO.index() + 1); //set row counter
                }
                $(MAIN_ROWDATA_ELEM).enableControls();
                setApproverPopover(trPO);
            }
        }
    }
    function setApproverPopover(container) {
        $('.approver-popover-icon', container || 'body').webuiPopover({
            trigger: 'hover',
            type: 'async',
            async: {
                type: 'POST'
            },
            padding: false
        });
    }


    function setPopupDialoge(message, waitTag, confirmTag, isLast, callbackPrefix) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            url: URL_IAS + 'PopupDialogue',
            params: {
                message: message,
                waitTag: waitTag,
                callbackPrefix: callbackPrefix,
                confirmTag: confirmTag,
                isLast: isLast
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            var modal = $('<div id="CONFIRMATION_MODAL" class="modal fade"></div>');
            modal.html(result.data).off().on('shown.bs.modal', function () {
                if (typeof (parentid) != "undefined") {
                    $(".modal-dialog", modal).attr("data-parentid", parentid);
                }
                me.setToolTipDestroy();
                me.CONTROL.setButton(true, modal);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                modal.remove();
            }).modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show');
        }
    };

    /*
    * ========================================================================
    * Partial Views
    * ========================================================================
    */


    function getPOModule() {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            url: URL_IAS + "GetPOModule",
            params: {
                poID: purchaseOrderOptions.poID,
                perspectiveType: purchaseOrderOptions.perspectiveType,
                prefilledPOItem: purchaseOrderOptions.prefilledPOItem || null,
                disabledFieldsItem: purchaseOrderOptions.disabledFieldsItem || null

            },
            callback: afterData,
            cancelprevious: true,
            isloader: true,
            loadingElements: purchaseOrderOptions.loadingElements,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (!result.data) {
                return;
            }
            labelList = me.getLabel();

            $('body').append(result.data);
            var modal = $(MODAL_ELEM);
            modal.off().on('shown.bs.modal', function () {
                child.UpdatePOModule();
                modal.enableControls();

                validateLineItem = false;
                lineitemChangeConfirmed = false;
                addNotePopup = false;
                isDirty = false;
                resubmitIsRequired = false;
                questionsChanged = false;

                me.setModalLock(false);
                if (purchaseOrderOptions.showCallback && typeof purchaseOrderOptions.showCallback === 'function') {
                    purchaseOrderOptions.showCallback();
                }
                const modalForm = modal.find('form');
                modalForm.bind('submit', function () {
                    $(this).find('input,select').prop('disabled', false);
                });

                modalForm.on('keyup keypress', function (e) {
                    var keyCode = e.keyCode || e.which;
                    if (keyCode === 13) {
                        e.preventDefault();
                        return false;
                    }
                });

            }).on('hidden.bs.modal', handlePOModuleCleanup).modal('show');
        }
    }



    /*
    * ========================================================================
    * Helper Functions
    * ========================================================================
    */

    function getEditVendorModal(data) {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.LOCATIONS.getEditModal({
                locationID: Number(data.e.data('parentid')),
                hideCallback: showPOModal
            });
        }).modal('hide');
    }

    function hideApproveDialogue(hideCallback) {
        $(APPROVE_MODAL).off().on('hidden.bs.modal', function () {
            $(APPROVE_MODAL).remove();
            me.setToolTip();

        }).modal('hide');
    }

    function getMigratePOModal(data) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);

        var options = {
            url: URL_IAS + 'GetMigratePOModal',
            params: {
                poID: Number(data.parentid)
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(MODAL_ELEM).off().on('hidden.bs.modal', function () {
                    $(MODAL_ELEM).off().html(result.data).on('shown.bs.modal', function () {
                        me.CONTROL.setButton(true, MODAL_ELEM);
                        me.CONTROL.setAutoComplete(MODAL_ELEM);
                        me.setModalLock(false);
                    }).on('hidden.bs.modal', function () {
                        $(MODAL_ELEM).remove();
                        me.setModalLock(false);
                        getPOModule();
                    }).modal('show');
                }).modal('hide');
            } else {
                me.setModalLock(true);
            }
        }
    }


    function getAddVendorModal() {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.LOCATIONS.getAddModal({
                allowExisting: false,
                hideCallback: showPOModal,
                addCallback: placeNewVendorInPO
            });
        }).modal('hide');
    }


    function showPOModal() {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', handlePOModuleCleanup).modal('show');
    }

    function addLineItem(data) {
        $('[name=AddLineItem]', MODAL_ELEM).val('true').change();
    }

    function deleteLineItem(data) {
        var lineItemElem = data.e.closest('.lineitem');
        $("[name*=Remove]", lineItemElem).val('true').change();
    }


    function handlePOModuleCleanup() {
        me.setToolTip();
        $(MODAL_ELEM).remove();
        $(ATTACH_FILE_MODAL).remove();
        contpaqSelectedAccountID = null;
        if (purchaseOrderOptions.hideCallback && typeof purchaseOrderOptions.hideCallback === 'function') {
            purchaseOrderOptions.hideCallback();
        }
    }


    function prepareDeclinePOConfirmation() {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.setConfirmDialogue(labelList['DecliningPODeletesPO'], tag.CONFIRM_DECLINEPO, tag.CANCEL_DECLINEPO, 'PURCHASE_ORDER');
        }).modal('hide');
    }

    function preparePopUpPOConfirmation() {
        var isLast = $("[data-fldname=IS_LAST_" + purchaseOrderCoSignersID + "]").val();
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            setPopupDialoge(labelList['ApprovePopUpPO'], tag.WAIT_APPROVER, tag.CONTINUE_APPROVE, isLast, 'PURCHASE_ORDER');
        }).modal('hide');
    }

    function expandCollapseSection(data) {
        var sectionID = data.e.parents().attr('id');
        if (data.e.find('i').hasClass('fa-caret-right')) {
            $('.box-content,.panel-body', data.e.closest('.box,.panel')).removeClass('hidden');
            data.e.find('i').removeClass('fa-caret-right').addClass('fa-caret-down');
            me.CONTROL.setTextArea(true, HARD_COPY_DETAILS);
            if (sectionID == "HARD_COPY_DETAILS") {
                collapseHardCopyDetails = false;
            }
        } else {
            $('.box-content,.panel-body', data.e.closest('.box,.panel')).addClass('hidden');
            data.e.find('i').removeClass('fa-caret-down').addClass('fa-caret-right');
            if (sectionID == "HARD_COPY_DETAILS") {
                collapseHardCopyDetails = true;
            }
        }
    }


    function handleETAUpdate(data) {
        $("[name*=ExpectedDeliveryDate]", LINE_ITEMS_CONTAINER).val(data.value);
    }


    function handlePurchasedMaterialSelect(data) {
        const currencyType = parseInt($("input[name='POItem.LineItemsList[0].CurrencyType']").val());
        if (currencyType != 0 &&
            currencyType != data.raw.currencyType) {
            data.e.data('initial', null).data('value', null).val('');
            $('[name*=PurchasedMaterialID]', data.e.closest('.lineitem')).val(null);
            notify.alert(labelList['MaterialCurrencyDoesnotMatch']);
            return;
        }
        var parentRow = data.e.closest('.lineitem');
        $('[name*=Price]', parentRow).val(0);
        $('[name*=UnitOfMeasureID]', parentRow).val(data.raw.unitType);
        $('[name*=Quantity]', parentRow).val("");
        $('[name*=PartDescription]', parentRow).val(data.raw.description);
        $('[name*=VendorPartNumber]', parentRow).val(data.raw.vendorPartNumber);
        $('[name*=CurrencyType]', parentRow).val(data.raw.currencyType);
        $('[name*=StandardCost]', parentRow).val(data.raw.standardCost);
        $('[name*=CosterCost]', parentRow).val(data.raw.costerCost);
        $('[name*=FirmZoneDays]', parentRow).val(null);
    }

    function handleContpaqLineItemSelect(data) {
        if (!data.raw.purchasedMaterialID) {
            notify.alert(labelList['ContpaqProductIsNotLinkedToAPurchasedMaterial']);
            return;
        }
        const currencyType = parseInt($("input[name='POItem.LineItemsList[0].CurrencyType']").val());
        if (currencyType != 0 &&
            currencyType != data.raw.currencyType) {
            data.e.data('initial', null).data('value', null).val('');
            $('[name*=PurchasedMaterialID]', data.e.closest('.lineitem')).val(null);
            notify.alert(labelList['MaterialCurrencyDoesnotMatch']);
            return;
        }

        var row = data.e.closest('.lineitem');

        $('[name*=Quantity]', row).val(data.raw.packageQty);
        $('[name*=UnitOfMeasureID]', row).val(data.raw.unitType);
        $('[name*=Price]', row).val(data.raw.unitPrice);
        $('[name*=FirmZoneDays]', row).val(data.raw.firmZoneDays);
        $('[name*=CurrencyType]', row).val(data.raw.currencyType);
        $('[name*=StandardCost]', row).val(data.raw.standardCost);
        $('[name*=CosterCost]', row).val(data.raw.costerCost);

        if (data.raw.accountID != parseInt($('[name*=".AccountID"]').val())) {
            if (row.siblings('.lineitem').filter(() => $('[name*=ContpaqProductID]', this).val() > 0).length) {
                notify.alert(labelList['SelectedContpaqProductDoesNotHaveTheSameAccountAsSelectedAbove']);
                data.e.data({ 'value': null, 'initial': null }).val(null);
            } else {
                $('[name*=ParentAccountID]').val(data.raw.parentAccountID);
                if ($('[name*=".AccountID"] option[value=' + data.raw.accountID + ']').length) {
                    $('[name*=".AccountID"]').val(data.raw.accountID);
                } else {
                    $('[name*=".AccountID"]').append('<option value="' + data.raw.accountID + '" selected/>');
                }
                notify.info(labelList['AccountWasAutomaticallyUpdatedToMatchContpaqProductsAccount']);
            }
        }
    }


    function handleMigratePurchasedMaterialSelect(data) {
        var options = {
            url: URL_IAS + 'HandlePurchasedMaterialSelect',
            params: {
                ID: Number(data.value),
                vendorID: -1
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                data.e.val(result.data.PartNumber).data('value', result.data.parentid).data('initial', result.data.PartNumber);
                var parentRow = data.e.closest('.lineitem');
                $('[data-fldname=PartDescription]', parentRow).val(result.data.PartDescription);
            }
        }
    }


    function handlePurchaseOrderMigrate(data) {
        if (!me.CONTROL.Validate(MODAL_ELEM)) {
            return;
        }

        var lineItemsList = $(".lineitem", MODAL_ELEM).map(function () {
            var item = me.getFormFields(this);
            item.PartNumber = $("[data-fldname=PurchasedMaterialID]", this).val();
            return item;
        }).toArray();

        var options = {
            url: URL_IAS + 'HandlePurchaseOrderMigrate',
            params: {
                poID: data.parentid,
                lineItemsList: lineItemsList
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(MODAL_ELEM).data("updated", true).modal('hide');
            }
        }
    }

    function handleLineItemUpdates(data) {
        if (isPurchasedMaterial && !currentStateItem.IsContpaqVendor) {
            switch (data.tag) {
                case tag.LINE_ITEM_PART_NUMBER:
                    poItem.PurchasedMaterialList[data.e.closest('.lineitem').index() - 1].PurchasedMaterialID = data.value;
                    break;
                case tag.LINE_ITEM_ETA:
                    poItem.PurchasedMaterialList[data.e.closest('.lineitem').index() - 1].ExpectedDeliveryDate = data.value;
                    break;
                case tag.LINE_ITEM_UNIT_OF_MEASURE:
                    poItem.PurchasedMaterialList[data.e.closest('.lineitem').index() - 1].UnitOfMeasureID = Number(data.value);
                    break;
            }
        } else {
            switch (data.tag) {
                case tag.LINE_ITEM_PART_NUMBER:
                    poItem.LineItemsList[data.e.closest('.lineitem').index() - 1].PartNumber = data.value;
                    break;
                case tag.LINE_ITEM_ETA:
                    poItem.LineItemsList[data.e.closest('.lineitem').index() - 1].ExpectedDeliveryDate = data.value;
                    break;
                case tag.LINE_ITEM_UNIT_OF_MEASURE:
                    poItem.LineItemsList[data.e.closest('.lineitem').index() - 1].UnitOfMeasureID = Number(data.value);
                    break;
            }
        }
        validateModalSection(data.e.closest('.box'));
    }

    function returnAttachmentModal(data) {
        var options = {
            url: URL_IAS + "GetAddAttachmentModal",
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(ATTACH_FILE_MODAL).html(result.data).off().on('shown.bs.modal', function () {
                    setFileDropzone();
                }).modal('show').enableControls();
            }
        }
    }

    function setFileDropzone() {
        //  don't load dz on init
        Dropzone.autoDiscover = false;
        const dZ = $(dropZone);
        if (dZ.length === 0) {
            return;
        }
        //  init
        dZ.dropzone({
            autoProcessQueue: false,
            uploadMultiple: false,
            parallelUploads: 1,
            maxFiles: 1,
            maxThumbnailFilesize: 1,
            clickable: true,
            url: URL_MEDIA,
            previewTemplate: "<div class='dz-preview row pt-10 dz-file-preview'>\n  <div class='col-xs-4 dz-image'><img data-dz-thumbnail class='wp-100' /></div>\n  <div class='col-xs-4 dz-details'>\n    <div class='dz-size'><span data-dz-size></span></div>\n    <div class='dz-filename'><span data-dz-name></span></div>\n  </div>\n  <div class='col-xs-3 dz-progress'><span class='dz-upload' data-dz-uploadprogress></span></div>\n  <div class='col-xs-4 dz-error-message'><span data-dz-errormessage></span></div>\n  <div class='hidden dz-success-mark'>\n    <svg width='54px' height='54px' viewBox='0 0 54 54' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'>\n      <title>Check</title>\n      <defs></defs>\n      <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'>\n        <path d='M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z' id='Oval-2' stroke-opacity='0.198794158' stroke='#747474' fill-opacity='0.816519475' fill='#FFFFFF' sketch:type='MSShapeGroup'></path>\n      </g>\n    </svg>\n  </div>\n  <div class='hidden dz-error-mark'>\n    <svg width='54px' height='54px' viewBox='0 0 54 54' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns'>\n      <title>Error</title>\n      <defs></defs>\n      <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' sketch:type='MSPage'>\n        <g id='Check-+-Oval-2' sketch:type='MSLayerGroup' stroke='#747474' stroke-opacity='0.198794158' fill='#FFFFFF' fill-opacity='0.816519475'>\n          <path d='M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z' id='Oval-2' sketch:type='MSShapeGroup'></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>",
            init: function () {
                this
                    .on("addedfile", function (file) {
                        if (currentFile) {
                            this.removeFile(currentFile);
                        }
                        currentFile = file;
                        $("#DROPZONE_AREA").text(file.filename);
                    });
            }
        });
    }

    function uploadFile(data) {

        if (!me.CONTROL.Validate(ATTACH_FILE_MODAL)) {
            return;
        }

        var invalidFilename = false;
        var secondarykeyid = data.e.closest(".modal-dialog").data("secondarykeyid");
        var item = me.getFormFields(ATTACH_FILE_MODAL);
        var formData = new FormData();

        const filename = currentFile.name ?? currentFile.filename;

        if (filename.search(/#/) > -1) {
            invalidFilename = true;
        }

        if (invalidFilename) {
            notify.alert(label['SymbolsNotSupported']);
            return;
        }

        formData.append(filename, currentFile);

        const poid = $('#POItem_ID').val();
        formData.append("EntityID", poid);
        formData.append("EntityType", -1);
        formData.append("AttachmentType", item.AttachmentType);
        formData.append("SecondaryKeyID", secondarykeyid);

        var options = {
            url: URL_IAS + 'UploadFile',
            params: formData,
            callback: afterData,
            isloader: true,
            processData: false,
            contentType: false,
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(ATTACH_FILE_MODAL).off('hidden.bs.modal').on('hidden.bs.modal', function () {
                    const $modal = $('form', MODAL_ELEM);
                    $modal.find('input,select').prop('disabled', false);
                    $modal.submit();
                    $('body').addClass("modal-open");
                }).modal('hide');
            }
        }
    }

    function deleteFile(data) {
        var lineItemElem = data.e.closest('tr');
        $("[name*=Remove]", lineItemElem).val('true').change();
    }

    function handleConfirmNewValue() {
        var note = "Price Changed From " + oldPrice + " To " + totalAmount;
        handleAddNote(note, iasApprovalStatus.NEEDS_APPROVAL);
    }

    /*
    * ========================================================================
    * Public Functions
    * ========================================================================
    */

    var activeControl;

    child.BeforeUpdatePOModule = function (data, xhr) {
        isdraft = $("#POItem_IsDraft").val() == "True" ? true : false;
        isNew = purchaseOrderOptions.perspectiveType == poModulePerspectiveType.ADD || purchaseOrderOptions.perspectiveType == poModulePerspectiveType.PREFILL ? true : false;

        const isDraftNewOrDuplicate = isdraft || isNew || purchaseOrderOptions.perspectiveType == poModulePerspectiveType.DUPLICATE;
        if (!lineitemChangeConfirmed && validateLineItem && !checkForAmountLimits() && !isDraftNewOrDuplicate) {
            $("#POItem_ResetApprovers").val('true');
            me.setConfirmDialogue(labelList['ChangeSubmittedPOValueBeyondAllowableParameter'], tag.CONFIRM_NEWVALUE, tag.CANCEL_NEWVALUE, 'PURCHASE_ORDER');
            return false;
        }

        if (isResubmitRequired() && !isDraftNewOrDuplicate) {
            $("#POItem_ResetApprovers").val('true');
            resubmitIsRequired = true;
        }

        if (questionsChanged && !isDraftNewOrDuplicate) {
            $("#POItem_ResetApprovers").val('true');
            resubmitIsRequired = true;
        }

        if (getTotalAmount() != getOldPrice() && !isDraftNewOrDuplicate) {
            $("#POItem_IsPriceChanged").val('true');
        }

        if (!lineitemChangeConfirmed && validateLineItem && checkForAmountLimits() && !questionsChanged && !isResubmitRequired() && !isDraftNewOrDuplicate) {
            $("#POItem_ResetApprovers").val('false');
        }

        // Must be last change to override previous false assertions
        const isAutoSignCosigner1 = !isDraftNewOrDuplicate && getTotalAmount() <= getCosignerThreshold();
        if (isAutoSignCosigner1) {
            $("#POItem_ResetApprovers").val('true');
        }

        if (resubmitIsRequired) {
            let isAdvisorFixed = parseFloat($("#OldAdvisorID").val()) == parseFloat($('[data-fldname="AdvisorID"]').data('value'))
                && $("#Cosign1Approval").val() == "APPROVED";
            $("#POItem_IsAdvisorFixed").val(isAdvisorFixed);
        } else {
            $("#POItem_IsAdvisorFixed").val('false');
        }

        if (addNotePopup) {
            showAddNoteModal('PURCHASE_ORDER');
            return false;
        }

        if (hasError) {
            hasError = false;
            return false;
        }

        $(this).addClass('form-processing');
        activeControl = $(":focus", this).attr('name');

        me.setTopProgressBar();
    }

    child.UpdatePOModule = function (data, result, xhr) {
        var modal = $(MODAL_ELEM);

        if (data) {
            // Only run on partial reload
            FD.unsetTopProgressBar();

            // We are clearing the html this way instead of using UpdateTargetId on the form as that is slow when there are a lot of DOM objects.
            if (data != true) {
                $(PURCHASEORDER_FORM)[0].innerHTML = '';
                $(PURCHASEORDER_FORM).html(data);
                if (collapseHardCopyDetails == false) {
                    $('.box-content,.panel-body', $(HARD_COPY_DETAILS)).removeClass('hidden');
                    $(HARD_COPY_DETAILS).find('i').removeClass('fa-caret-right').addClass('fa-caret-down');
                    me.CONTROL.setTextArea(true, HARD_COPY_DETAILS);
                }
            }

            if (xhr.getResponseHeader('SaveDraftMode') == 'True' || xhr.getResponseHeader('SaveDraftMode') == 'False' || data == true) {
                if (xhr.getResponseHeader('IsNew') == 'True') {
                    purchaseOrderOptions.poID = parseInt(xhr.getResponseHeader('POID'));
                    if (purchaseOrderOptions.addCallback && typeof purchaseOrderOptions.addCallback === 'function') {
                        purchaseOrderOptions.addCallback(purchaseOrderOptions.poID);
                        $(MODAL_ELEM + ' .modal-footer .btn-primary').attr('disabled', false).prop('disabled', false);
                    }
                } else {
                    if (purchaseOrderOptions.updateCallback && typeof purchaseOrderOptions.updateCallback === 'function') {
                        purchaseOrderOptions.updateCallback(purchaseOrderOptions.poID);
                    }
                }

                if (xhr.getResponseHeader('SaveDraftMode') == 'True') {

                } else {
                    modal.off('hidden.bs.modal').on('hidden.bs.modal', () => handlePOModuleCleanup());
                    modal.modal('hide');
                }
            } else {
                if (xhr.getResponseHeader('POID')) {
                    purchaseOrderOptions.poID = parseInt(xhr.getResponseHeader('POID'));
                    if (xhr.getResponseHeader('IsNew') == 'True') {
                        return handlePurchaseOrderAddCRUD(data);
                    } else {
                        return handlePurchaseOrderUpdate(xhr.getResponseHeader('IsExport') == 'True', data);
                    }
                }
            }

            $('[name="' + activeControl + '"]', this).focus();
            $(this).removeClass('form-processing');
        }

        $(PURCHASEORDER_FORM).enableControls();
        me.CONTROL.setValidateContainer(modal);

        if (purchaseOrderOptions.perspectiveType === poModulePerspectiveType.EDIT || purchaseOrderOptions.perspectiveType === poModulePerspectiveType.VIEW) {
            var clipboard = new Clipboard(MODAL_ELEM + ' .copyBtn');
        }
        me.pinElements(modal);

        $('[name*=Quantity][data-clearonload]', this).val("");
        if (showAttachment) {
            showAttachment = false;
            $(MODAL_ELEM).find('[data-ajax-update="' + ATTACH_FILE_MODAL + '"]').trigger("click");
            setFileDropzone();
        }
    }

    /*
     * Options
     *  addCallback: called when PO is submitted
     *  hideCallback: called when PO module is hidden
     */
    child.getAddPOModal = function (userOptions) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, addDefaults, userOptions);
        getPOModule();
    };


    /*
     * Options
     *  poID [required]: ID of PO being edited
     *  updateCallback: called when PO update is submitted successfully
     *  hideCallback: called when PO module is hidden
     */
    child.getEditPOModal = function (userOptions) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, editDefaults, userOptions);
        getPOModule();
    };


    /*
     * Options
     *  poID [required]: ID of PO being viewed
     *  hideCallback: called when PO module is hidden
     */
    child.getViewPOModal = function (userOptions) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, viewDefaults, userOptions);
        getPOModule();
    };


    /*
     * Options
     *  poID [required]: ID of PO being duplicated
     *  addCallback: called when PO is submitted
     *  hideCallback: called when PO module is hidden
     */
    child.getDuplicatePOModal = function (userOptions) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, duplicateDefaults, userOptions);
        getPOModule();
    };


    /*
     * Options
     *  poID [required]: ID of PO being approved
     *  updateApprovalCallback: called when PO approval status is successfully updated
     *  updateAlignmentCallback: called when PO alignment status is successfully updated
     *  hideCallback: called when PO module is hidden
     */
    child.getApprovePOModal = function (userOptions) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, approveDefaults, userOptions);
        getPOModule();
    };


    child.handleModalClose = function () {
        $('body').addClass("modal-open");
    }


    /*
     * Options
     *      addCallback: called when PO is submitted
     *      hideCallback: called when PO module is hidden
     * prefilledPOItem: POItem object with any pre-filled values filled in. Must match POItem Model
     * disabledFieldsItem: PODisabledFieldsItem object 
     *      Note: You only need to provide a value for the fields that need to be locked. The rest are enabled automatically     *  
     */
    child.getPrefilledPOModal = function (userOptions, prefilledPOItem, disabledFieldsItem) {
        notify = notify || new Notify();
        purchaseOrderOptions = $.extend({}, prefillDefaults, userOptions);
        purchaseOrderOptions.prefilledPOItem = prefilledPOItem;
        purchaseOrderOptions.disabledFieldsItem = disabledFieldsItem;
        getPOModule();
    };


    child.getMigratePOModal = function (poID, updateCallback) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);

        var options = {
            url: URL_IAS + 'GetMigratePOModal',
            params: {
                poID: poID
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $("body").append('<div id="PURCHASEORDER_MODAL" class="modal fade" data-parent="true" data-parentid="' + poID + '" data-callbackprefix="' + CALLBACK_PREFIX + '"></div>');
                $(MODAL_ELEM).off().html(result.data).on('shown.bs.modal', function () {
                    me.setModalLock(false);
                    me.CONTROL.setButton(true, MODAL_ELEM);
                    me.CONTROL.setAutoComplete(MODAL_ELEM);
                }).on('hidden.bs.modal', function (e) {
                    if ($(MODAL_ELEM).data('updated')) {
                        updateCallback.call(this);
                    }
                    $(MODAL_ELEM).remove();
                }).modal('show');
            } else {
                me.setModalLock(false);
            }
        }
    };


    function showAddNoteModal(callbackPrefix) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            url: URL_IAS + 'AddNoteModal',
            params: {
                callbackPrefix: callbackPrefix
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            var modal = $('<div id="CONFIRMATION_MODAL" class="modal fade"></div>');
            modal.html(result.data).off().on('shown.bs.modal', function () {
                if (typeof (parentid) != "undefined") {
                    $(".modal-dialog", modal).attr("data-parentid", parentid);
                }
                modal.enableControls();
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                modal.remove();
            }).modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show');
        }
    };

    function handleAddNote(note, approvalStatus) {
        me.hideConfirmDialogue();
        approvalUpdateItem = setPOApprovalUpdateItem();
        approvalUpdateItem.PurchaseOrderCoSignersID = null;
        approvalUpdateItem.Comment = note;
        approvalUpdateItem.ApprovalStatus = approvalStatus;

        var options = {
            url: URL_IAS + 'HandlePurchaseOrderCosignerStatusCRUD',
            params: { item: approvalUpdateItem },
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData() {
            addNotePopup = false;
            isDirty = false;
            validateLineItem = false;
            resubmitIsRequired = false;
            lineitemChangeConfirmed = true;
            $(MODAL_ELEM).find('[data-tag="72"]').trigger("click");
        }
    }

    function hundleSubmitWithAttachment() {
        me.hideConfirmDialogue();
        if (parseInt($("#POItem_ID").val()) == 0) {
            showAttachment = true;
            $(MODAL_ELEM).find('[data-tag="' + tag.SAVE_DRAFT + '"]').first().trigger("click");
        } else {
            $(MODAL_ELEM).find('[data-ajax-update="' + ATTACH_FILE_MODAL + '"]').trigger("click");
            setFileDropzone();
        }

    }

    function hundleSubmitWithoutAttachment() {
        me.hideConfirmDialogue();
        forceSubmitWithoutAttachment = true;
        $(MODAL_ELEM).find('[data-tag="' + tag.SUBMIT_FOR_APPROVAL + '"]').trigger("click");
    }

    function handlePurchaserComment(data, hasWaitingUser) {
        approvalUpdateItem = setPOApprovalUpdateItem();
        approvalUpdateItem.PurchaseOrderCoSignersID = purchaseOrderCoSignersID;
        approvalUpdateItem.Comment = $("[data-fldname=APPROVAL_COMMENT_" + purchaseOrderCoSignersID + "]").val();
        approvalUpdateItem.ApprovalStatus = iasApprovalStatus.EDITING;

        var options = {
            url: URL_IAS + 'HandlePurchaserComment',
            params: {
                item: approvalUpdateItem,
                hasWaitingUser
            },
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        if (approvalUpdateItem.Comment == "") {
            notify.alert(labelList["CommentIsRequired"]);
        } else {
            me.AJAX.setAJAX(options);
        }

        function afterData(result) {
            $(APPROVAL_BODY).html(result.data).enableControls();
        }
    }

    function handlePOPurchaserCommentCRUD() {
        var purchaserComment = $("[data-fldname=APPROVAL_COMMENT_" + purchaseOrderCoSignersID + "]").val();
        var options = {
            url: URL_IAS + 'HandlePOPurchaserCommentCRUD',
            params: {
                purchaseOrderCoSignersID,
                lowestPurchaseOrderCoSignerID,
                poID: purchaseOrderOptions.poID,
                comment: purchaserComment
            },
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        if (purchaserComment == "") {
            notify.alert(labelList["CommentIsRequired"]);
        } else {
            me.AJAX.setAJAX(options);
        }

        function afterData(result) {
            $(APPROVAL_BODY).html(result.data).enableControls();
        }
    }

    function openNewRevisionModal() {
        var options = {
            url: URL_IAS + 'OpenNewRevisionModal',
            params: {
                poID: purchaseOrderOptions.poID,
                callbackPrefix: 'PURCHASE_ORDER'
            },
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            var modal = $('<div id="CONFIRMATION_MODAL" class="modal fade"></div>');
            modal.html(result.data).modal({
                backdrop: 'static',
                keyboard: false
            }).modal('show').enableControls();
        }
    }

    function returnRevisionLineList() {
        let lineItemList = getLineItemList();

        var options = {
            url: URL_IAS + 'ReturnRevisionLineList',
            params: {
                purchasedOrderID: purchaseOrderOptions.poID,
                lineItemList: lineItemList
            },
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            $(NEW_REVISION_LINE_ITEM_TABLE).html(result.data).enableControls();
        }
    }

    function addRevisionLineItem() {
        let lineItemList = getLineItemList();

        var options = {
            url: URL_IAS + 'AddRevisionLineItem',
            params: {
                purchasedOrderID: purchaseOrderOptions.poID,
                lineItemList: lineItemList
            },
            isloader: true,
            ishtml: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            $(NEW_REVISION_LINE_ITEM_TABLE).html(result.data).enableControls();
        }
    }

    function getLineItemList() {
        let lineItemList = [];
        $.each($(NEW_REVISION_LINE_ITEM_TABLE).find('tr:not(.footer)'), function (key, item) {
            let tr = $(item);

            lineItemList.push(
                {
                    POItemID: tr.find("input[data-fldname='POItemID']").val(),
                    ContpaqProductID: tr.find("input[data-fldname='ContpaqProductID']").val(),
                    CurrencyType: tr.find("input[data-fldname='CurrencyType']").val(),
                    PartNumber: tr.find("input[data-fldname='PartNumber']").val(),
                    VendorPartNumber: tr.find("input[data-fldname='VendorPartNumber']").val(),
                    PartDescription: tr.find("input[data-fldname='PartDescription']").val(),
                    Quantity: tr.find("input[data-fldname='Quantity']").val(),
                    UnitOfMeasureID: tr.find("select[data-fldname='UnitOfMeasureID']").val(),
                    Price: tr.find("input[data-fldname='Price']").val(),
                    CosterCost: tr.find("input[data-fldname='CosterCost']").val(),
                    StandardCost: tr.find("input[data-fldname='StandardCost']").val(),
                    ExpectedDeliveryDate: tr.find("input[data-fldname='ExpectedDeliveryDate']").val(),
                    LineItemType: tr.find("input[data-fldname='LineItemType']").val(),
                    PurchasedMaterialID: tr.find("input[data-fldname='PurchasedMaterialID']").val(),
                    FirmZoneDays: tr.find("input[data-fldname='FirmZoneDays']").val(),
                }
            );
        });

        return lineItemList;
    }

    function addPurchasedMaterial(data) {
        const currencyType = parseInt($("input[name='POItem.LineItemsList[0].CurrencyType']").val());
        if (currencyType != 0 &&
            currencyType != data.raw.currencyType) {
            data.e.data('initial', null).data('value', null).val('');
            $('[name*=PurchasedMaterialID]', data.e.closest(RevLineItem)).val(null);
            notify.alert(labelList['MaterialCurrencyDoesnotMatch']);
            return;
        }
        var parentRow = data.e.closest(RevLineItem);
        $('[name*=Price]', parentRow).val(0);
        $('[name*=UnitOfMeasureID]', parentRow).val(data.raw.unitType);
        $('[name*=Quantity]', parentRow).val("");
        $('[name*=PartDescription]', parentRow).val(data.raw.description);
        $('[name*=VendorPartNumber]', parentRow).val(data.raw.vendorPartNumber);
        $('[name*=CurrencyType]', parentRow).val(data.raw.currencyType);
        $('[name*=StandardCost]', parentRow).val(data.raw.standardCost);
        $('[name*=CosterCost]', parentRow).val(data.raw.costerCost);
        $('[name*=PurchasedMaterialID]', parentRow).val(data.raw.value);
        $('[name*=FirmZoneDays]', parentRow).val(null);

        returnRevisionLineList();
    }

    function addContpaqLineItem(data) {
        if (!data.raw.purchasedMaterialID) {
            notify.alert(labelList['ContpaqProductIsNotLinkedToAPurchasedMaterial']);
            return;
        }
        const currencyType = parseInt($("input[name='POItem.LineItemsList[0].CurrencyType']").val());
        if (currencyType != 0 &&
            currencyType != data.raw.currencyType) {
            data.e.data('initial', null).data('value', null).val('');
            $('[name*=PurchasedMaterialID]', data.e.closest(RevLineItem)).val(null);
            notify.alert(labelList['MaterialCurrencyDoesnotMatch']);
            return;
        }

        var row = data.e.closest(RevLineItem);

        $('[name*=Quantity]', row).val(data.raw.packageQty);
        $('[name*=UnitOfMeasureID]', row).val(data.raw.unitType);
        $('[name*=Price]', row).val(data.raw.unitPrice);
        $('[name*=FirmZoneDays]', row).val(data.raw.firmZoneDays);
        $('[name*=CurrencyType]', row).val(data.raw.currencyType);
        $('[name*=StandardCost]', row).val(data.raw.standardCost);
        $('[name*=CosterCost]', row).val(data.raw.costerCost);
        $('[name*=ContpaqProductID]', row).val(data.raw.value);

        if (data.raw.accountID != parseInt($('[name*=".AccountID"]').val())) {
            if (row.siblings(RevLineItem).filter(() => $('[name*=ContpaqProductID]', this).val() > 0).length) {
                notify.alert(labelList['SelectedContpaqProductDoesNotHaveTheSameAccountAsSelectedAbove']);
                data.e.data({ 'value': null, 'initial': null }).val(null);
            } else {
                $('[name*=ParentAccountID]').val(data.raw.parentAccountID);
                if ($('[name*=".AccountID"] option[value=' + data.raw.accountID + ']').length) {
                    $('[name*=".AccountID"]').val(data.raw.accountID);
                } else {
                    $('[name*=".AccountID"]').append('<option value="' + data.raw.accountID + '" selected/>');
                }
                notify.info(labelList['AccountWasAutomaticallyUpdatedToMatchContpaqProductsAccount']);
            }
        }
        returnRevisionLineList();
    }

    function createMaterialPurchaseOrderRevision(data) {
        if (!me.CONTROL.Validate("#CONFIRMATION_MODAL")) {
            return;
        }
        var item = me.getFormFields("#CONFIRMATION_MODAL");

        let lineItemList = getLineItemList();

        var options = {
            url: URL_IAS + 'CreateMaterialPurchaseOrderRevision',
            params: {
                purchasedOrderID: purchaseOrderOptions.poID,
                advisorID: item.AdvisorID,
                comments: item.Comments,
                lineItemList: lineItemList
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                if (result.data == 1) {
                    notify.alert(labelList["ThisPOAlreadyHave99RevisionsCannotMakeAnotherOne"]);
                } else if (result.data == 2) {
                    notify.alert(labelList["ThisPOIsNotABlanketPO"]);
                } else if (result.data == 3) {
                    notify.alert(labelList["POHasAlreadyBeenRevised"]);
                } else {
                    window.location.href = "/IAS/IAS?POID=" + result.data;
                }
            } else {
                notify.alert(labelList["YouCannotBeTheCosignerForAPOYouCreate"]);
            }
        }
    }

    function createPurchaseOrderOtherTeammate(data) {
        $('[name=AddOtherTeammate]', MODAL_ELEM).val('true');
        $('[name=AddOtherTeammateName]', MODAL_ELEM).val(data.label);
    }

    function deletePurchaseOrderOtherTeammate(data) {
        var teammateItemElem = data.e.closest('.teammateItem');
        $("[name*=Remove]", teammateItemElem).val('true').change();
    }

    //   after control event
    child.getAfterControlEvent = function (data) {
        switch (data.tag) {
            // Other Module Interactions
            case tag.ADD_VENDOR:
                getAddVendorModal();
                break;
            case tag.EDIT_VENDOR:
                getEditVendorModal(data);
                break;

            // Line Item Functionality
            case tag.ADD_LINE_ITEM:
                addLineItem(data);
                break;
            case tag.DELETE_LINE_ITEM:
                deleteLineItem(data);
                break;
            case tag.LINE_ITEM_QTY:
                var receivedQty = parseFloat(data.e.data('receivedquantity').toString().replaceAll(',', ''));
                var qty = parseFloat(data.value.toString().replaceAll(',', ''));
                if (qty < receivedQty) {
                    data.e.val(data.e.data('initialquantity'));
                    notify.alert(labelList['QuantityCannotBeLessThanReceivedQuantity'] + ' ' + receivedQty);
                }
            case tag.LINE_ITEM_PRICE:
                validateLineItem = false;
                addNotePopup = false;
                break;
            case tag.JOB_ID:
            case tag.DIVISION:
            case tag.CELL:
            case tag.PARENTACCOUNT:
            case tag.ACCOUNT:
            case tag.PO_DESCRIPTION:
            case tag.PO_ADVISOR:
            case tag.SELECT_POTYPE:
            case tag.SELECT_POSTATUS:
            case tag.VENDOR:
            case tag.CURRENCY:
            case tag.CREDIT_CARD:
            case tag.SHIPPING_TERMS:
            case tag.SUPPLIER_CONTACT:
            case tag.SHIP_VIA:
            case tag.SHIP_TO:
            case tag.SHIP_TO_CONTACT:
            case tag.DOCK_NUMBER:
            case tag.SALES_TAX:
            case tag.SHIPPING_AND_HANDLING:
            case tag.DISCOUNT:
            case tag.SPECIAL_NOTES:
            case tag.LINE_ITEM_PART_NUMBER:
                isDirty = true;
                break;
            case tag.ECN:
            case tag.ToolingBuild:
            case tag.Tooling:
            case tag.MachineBuild:
                questionsChanged = true;
                isDirty = true;
                break;

            // NEW Approval Functionality
            case tag.APPROVE:
                purchaseOrderCoSignersID = data.e.data('fldname');
                isLastCosigner = $("[data-fldname=IS_LAST_" + purchaseOrderCoSignersID + "]").val();
                handleApprovalStatus(data);
                break;
            case tag.SHOW_POPUP:
                purchaseOrderCoSignersID = data.e.data('fldname');
                isLastCosigner = $("[data-fldname=IS_LAST_" + purchaseOrderCoSignersID + "]").val();
                preparePopUpPOConfirmation(data);
                break;
            case tag.WAIT_MOREINFO:
                purchaseOrderCoSignersID = data.e.data('fldname');
                isLastCosigner = $("[data-fldname=IS_LAST_" + purchaseOrderCoSignersID + "]").val();
                handleApprovalStatus(data);
                break;
            case tag.DECLINEPO:
                purchaseOrderCoSignersID = data.e.data('fldname');
                isLastCosigner = $("[data-fldname=IS_LAST_" + purchaseOrderCoSignersID + "]").val();
                handleApprovalStatus(data);
                break;
            case tag.CONTINUE_APPROVE:
                hideApproveDialogue(showPOModal);
                handleApprovalStatus(data);
                break;
            case tag.WAIT_APPROVER:
                handleApprovalStatus(data);
                hideApproveDialogue(showPOModal);
                break;
            case tag.TOGGLE_SECTION:
                expandCollapseSection(data);
                break;
            case tag.SAVE_DRAFT:
                handleSaveDraft(data);
                break;
            case tag.SAVE_AND_EXPORT_PO:
                handlePOSubmit(data, true);
                break;
            case tag.SAVEBTN:
            case tag.SUBMIT_FOR_APPROVAL:
                handlePOSubmit(data);
                break;

            case tag.LINE_ITEM_MATERIAL:
                handlePurchasedMaterialSelect(data);
                break;
            case tag.LINE_ITEM_CONTPAQ_ID:
                handleContpaqLineItemSelect(data);
                break;
            case tag.ETA:
                isDirty = true;
                handleETAUpdate(data);
                break;

            //Supporting Documentation
            case tag.UPLOAD_DOCUMENT:
                returnAttachmentModal();
                break;
            case tag.ENTITY_ATTACHMENT_ADD:
                uploadFile(data);
                break;
            case tag.ENTITY_ATTACHMENT_REMOVE:
                deleteFile(data);
                break;

            case tag.BTN_EDIT_PO_RESULT:
                $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
                    handlePOModuleCleanup();
                    purchaseOrderOptions.poID = Number(data.parentid);
                    purchaseOrderOptions.updateCallback = purchaseOrderOptions.addCallBack;
                    purchaseOrderOptions.perspectiveType = poModulePerspectiveType.EDIT;
                    getPOModule();
                }).modal('hide');
                break;
            case tag.BTN_ADD_PO_RESULT:
                $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
                    handlePOModuleCleanup();
                    purchaseOrderOptions.perspectiveType = poModulePerspectiveType.ADD;
                    purchaseOrderOptions.poID = null;
                    getPOModule();
                }).modal('hide');
                break;
            case tag.MIGRATE_OPEN_MODAL:
                getMigratePOModal(data);
                break;
            case tag.MIGRATE_LINE_ITEM_MATERIAL:
                handleMigratePurchasedMaterialSelect(data);
                break;
            case tag.MIGRATE_SUBMIT:
                handlePurchaseOrderMigrate(data);
                break;
            case tag.CONFIRM_NEWVALUE:
                handleConfirmNewValue();
                break;
            case tag.CONFIRM_RESUBMIT:
                me.hideConfirmDialogue();
                showAddNoteModal('PURCHASE_ORDER');
                break;
            case tag.CANCEL_NEWVALUE:
                me.hideConfirmDialogue(() => {
                    $('body').addClass("modal-open");
                });
                break;
            case tag.CONFIRM_ADD_NOTE:
                var note = $("[data-fldname=NoteText]").val();
                if (note == null || note == "") {
                    notify.alert(labelList["NoteIsEmpty"]);
                } else {
                    if (addNotePopup) {
                        note += " - Price Changed From " + oldPrice + " To " + totalAmount;
                    }
                    handleAddNote(note, iasApprovalStatus.EDITING);
                }
                break;
            case tag.SUBMIT_WITH_ATTACHMENT:
                hundleSubmitWithAttachment();
                break;
            case tag.SUBMIT_WITHOUT_ATTACHMENT:
                hundleSubmitWithoutAttachment();
                break;

            case tag.PURCHASER_COMMENT_CONTINUE:
                purchaseOrderCoSignersID = data.e.data('fldname');
                handlePurchaserComment(data, true);
                break;
            case tag.PURCHASER_COMMENT_RESUBMIT:
                purchaseOrderCoSignersID = data.e.data('fldname');
                lowestPurchaseOrderCoSignerID = data.e.data('waitinguserid');
                handlePOPurchaserCommentCRUD(data);
                break;
            case tag.PURCHASER_ADD_COMMENT:
                purchaseOrderCoSignersID = data.e.data('fldname');
                handlePurchaserComment(data, false);
                break;

            case tag.CREATE_NEW_REVISION:
                openNewRevisionModal();
                break;
            case tag.APPROVE_NEW_REVISION:
                createMaterialPurchaseOrderRevision(data);
                break;
            case tag.DELETE_REV_LINE_ITEM:
                if ($(RevLineItem).length > 1) {
                    data.e.parents('tr').remove();
                } else {
                    notify.alert(labelList['YouMustHaveAtLeastOneLineItemOrPurchasedMaterial']);
                }
                break;
            case tag.ADD_REV_LINE_ITEM:
                addRevisionLineItem();
                break;
            case tag.ADD_REV_PurchasedMaterial:
                addPurchasedMaterial(data);
                break;
            case tag.ADD_REV_ContpaqProduct:
                addContpaqLineItem(data);
                break;
            case tag.Add_Other_Teammate:
                createPurchaseOrderOtherTeammate(data);
                break;
            case tag.Delete_Other_Teammate:
                deletePurchaseOrderOtherTeammate(data);
                break;
        }
    };

    return child;
}(jQuery, FD));